import React, { Component } from 'react';
import {
    Button,
    CircularProgress,
    Divider, Grid, Snackbar,
} from "@mui/material";
import { Link, useNavigate } from 'react-router-dom';
import { Product } from "../../../classes/types/product/product";
import { Alert, Pagination } from "@mui/lab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons/faBoxOpen";
import { LaterListHandler } from "../../../classes/methods/laterListMethods/laterListMethods";
import { LaterList, LaterListProduct } from "../../../classes/types/laterList/laterList";
import LaterListProductCard from "../../customComponents/laterListProductCard/laterListProductCard";
import NotLoggedIn from '../../customComponents/notLoggedIn/NotLoggedIn';
import CartEvents from "../../../classes/events/CartEvents";
import LoginEvent from "../../../classes/events/LoginEvent";

interface props {
    navigate: ReturnType<typeof useNavigate>;
    page?: string;
    products?: Array<Product>;
}

interface state {
    loading: boolean,
    products: LaterList,
    loggedIn: boolean,
    pageProducts: LaterList,
    productToView: LaterList,
    currentPage: number,
    pageNumber: number,
    numberProductsInPage: number,
    productsToView: LaterList,
    openRemovedSnackBar: boolean,
    isLogged: boolean,
}

class LaterListProducts extends Component<props, state> {
    constructor(props: props) {
        super(props);
        this.state = {
            products: new LaterList(),
            pageProducts: new LaterList(),
            loggedIn: false,
            productToView: new LaterList(),
            numberProductsInPage: 20,
            currentPage: this.props.page !== undefined ? Number(this.props.page) : 1,
            pageNumber: 1,
            loading: true,
            productsToView: new LaterList(),
            openRemovedSnackBar: false,
            isLogged: false,
        }
    }

    componentDidMount() {
        this.refreshData();
    }

    componentDidUpdate(prevProps: Readonly<props>) {
        if (this.props.page !== prevProps.page) {
            this.refreshData();
        }
    }

    refreshData = () => {
        this.setState({ loading: true });
        LaterListHandler.GetLaterList().then((laterList) => {
            let newPageNumber = Math.ceil(laterList.products.length / this.state.numberProductsInPage);

            let startingPoint = 0;
            let currentPage = 1;
            if (this.props.page) {
                const pageNum = Number(this.props.page);
                if (pageNum <= 0 || pageNum > newPageNumber || isNaN(pageNum)) {
                    this.onPageChange(1);
                } else {
                    startingPoint = (pageNum - 1) * this.state.numberProductsInPage;
                    currentPage = pageNum;
                }
            }

            const newProductsPage = new LaterList();
            let count = 0;
            for (let i = startingPoint; i < laterList.products.length; i++) {
                if (count < this.state.numberProductsInPage) {
                    newProductsPage.products.push(laterList.products[i]);
                } else break;
                count++;
            }

            this.setState({
                loading: false,
                currentPage,
                loggedIn: true,
                products: laterList,
                pageProducts: newProductsPage,
                productsToView: laterList,
                pageNumber: newPageNumber,
                isLogged: this.isLogged(laterList.products),
            });
        }).catch((err) => {
            CartEvents.callCartModifiedEvents();
            LoginEvent.callLoginEvents();
            this.setState({ loading: false, loggedIn: false });
        });
    }

    isLogged = (products: Array<LaterListProduct>) => {
        return products.some(p => !p.product.configurable && p.product.price !== undefined);
    }

    onPageChange = (page: number) => {
        window.history.pushState(null, "GIGABYTE DISTRIBUZIONE", `/shop/saved/page/${page}`);
        const newProductsPage = new LaterList();
        const startingPoint = (page - 1) * this.state.numberProductsInPage;
        let count = 0;
        for (let i = startingPoint; i < this.state.productsToView.products.length; i++) {
            if (count < this.state.numberProductsInPage) newProductsPage.products.push(this.state.productsToView.products[i]);
            else break;
            count++;
        }
        this.setState({ pageProducts: newProductsPage, currentPage: page });
    }

    onListProductRemoved = (laterListProductId: string) => {
        const productCopy = { ...this.state.products };
        productCopy.products = productCopy.products.filter(p => p.id !== laterListProductId);

        const newPageNumber = Math.ceil(productCopy.products.length / this.state.numberProductsInPage);
        const currentPage = Math.min(this.state.currentPage, newPageNumber) || 1;

        const newProductsPage = new LaterList();
        const startingPoint = (currentPage - 1) * this.state.numberProductsInPage;
        let count = 0;
        for (let i = startingPoint; i < productCopy.products.length; i++) {
            if (count < this.state.numberProductsInPage) newProductsPage.products.push(productCopy.products[i]);
            else break;
            count++;
        }

        LaterListHandler.deleteProductFromLaterList(laterListProductId).then(() => {
            this.setState({
                openRemovedSnackBar: true,
                currentPage,
                pageProducts: newProductsPage,
                productsToView: productCopy,
                pageNumber: newPageNumber,
                products: productCopy,
            });
        }).catch(console.log);
    }

    CustomFilterList = () => (
        <div style={{ wordBreak: "break-word", marginBottom: '10%' }}>
            <Grid container>
                <Grid xs={12} item>
                    {this.state.products.products.length < 1 ? (
                        <div style={{ marginTop: '10%' }}>
                            <FontAwesomeIcon style={{ marginTop: "10px", color: "grey", fontSize: "10vw" }} icon={faBoxOpen} />
                            <h1>Nessun prodotto salvato</h1>
                            <Link to="/"><Button variant="contained" color="primary">Ritorna alla Pagina Iniziale</Button></Link>
                        </div>
                    ) : this.state.pageProducts.products.length < 1 ? (
                        <div style={{ marginTop: '10%' }}>
                            <FontAwesomeIcon style={{ marginTop: "10px", color: "grey", fontSize: "10vw" }} icon={faBoxOpen} />
                            <h1>Non Esistono Prodotti Con Queste Specifiche</h1>
                        </div>
                    ) : (
                        <div style={{ paddingLeft: '2%', paddingRight: '2%' }} className="configurable-systems">
                            <div key="pagination1" style={{ display: "flex", flexDirection: "row", justifyContent: "center", padding: "0.5% 0% 1% 0%" }}>
                                <Pagination color="primary" count={this.state.pageNumber} page={this.state.currentPage} onChange={(e, p) => this.onPageChange(p)} />
                            </div>
                            <Divider variant="middle" style={{ marginBottom: '1%' }} />
                            {this.state.pageProducts.products.map((laterListProduct, index) => (
                                <div key={index}>
                                    <LaterListProductCard
                                        isLogged={this.state.isLogged}
                                        removed={this.onListProductRemoved}
                                        laterListProductId={laterListProduct.id}
                                        linkName={`/shop/saved/page/${this.state.currentPage}/prodotto/${laterListProduct.product.id}?savedId=${laterListProduct.id}`}
                                        loading={this.state.loading}
                                        image={laterListProduct.image}
                                        product={laterListProduct.product}
                                    />
                                    <Divider variant="middle" style={{ marginBottom: '1%' }} />
                                </div>
                            ))}
                            <div key="pagination2" style={{ display: "flex", flexDirection: "row", justifyContent: "center", padding: "0.5% 0% 1% 0%" }}>
                                <Pagination color="primary" count={this.state.pageNumber} page={this.state.currentPage} onChange={(e, p) => this.onPageChange(p)} />
                            </div>
                        </div>
                    )}
                </Grid>
            </Grid>
            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: 'right' }}
                open={this.state.openRemovedSnackBar}
                autoHideDuration={6000}
                onClose={() => this.setState({ openRemovedSnackBar: false })}
            >
                <Alert onClose={() => this.setState({ openRemovedSnackBar: false })} severity="success">
                    {"Il prodotto è stato rimosso con successo!"}
                </Alert>
            </Snackbar>
        </div>
    );

    render() {
        return (
            <div style={{ paddingLeft: "50px", paddingRight: "50px" }}>
                {!this.state.loading ? (
                    this.state.loggedIn ? (
                        <>
                            <h1 style={{ textAlign: "left", marginTop: "2%", marginBottom: "2%", fontSize: "25px" }}>Salvati per dopo</h1>
                            <this.CustomFilterList />
                        </>
                    ) : <NotLoggedIn />
                ) : <CircularProgress />}
            </div>
        );
    }
}

// --- Wrapper per React Router v6
export default function LaterListProductsWrapper(props: any) {
    const navigate = useNavigate();
    return <LaterListProducts {...props} navigate={navigate} />;
}
